import { memo } from 'react'
import LunWenStep from './LunWenStep/LunWenStep'
import PptStep from './PptStep/PptStep'
import ReduceStep from './ReduceStep/ReduceStep'
import AIGCStep from './AIGCStep/AIGCStep'
import LayoutStep from './LayoutStep/LayoutStep'

const StepNav = (props: any) => {
  const { step, type } = props
  return (
    <>
      {type == 1 && <LunWenStep step={step} />}
      {type == 2 && <PptStep step={step} />}
      {type == 3 && <ReduceStep step={step} />}
      {type == 4 && <AIGCStep step={step} />}
      {type == 5 && <LayoutStep step={step} />}
    </>
  )
}

export default memo(StepNav)
